<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page

========================================================================================== -->

<template>
  <div id="page-user-view">

    <vs-alert color="danger" title="Simulation Not Found" v-if="errorOccurred">
      <span>Simulation record with id:  not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'management-list-simulation'}"
                                        class="text-inherit underline">All Simulation</router-link>
      </span>
    </vs-alert>

    <div id="course-data" v-else>


      <!-- Avatar -->
      <div class="vx-row match-height">
        <div class="vx-col lg:w-4/12 w-full">
          <!-- Avatar Col -->
          <vx-card title="Simulation Overview" class="mb-base">
            <div class="vx-row">
              <div class="vx-col " id="avatar-col">
                <div class="img-container mb-5">
                  <img v-if="simulation_data"
                    :src="simulation_data.thumbnail ? simulation_data.thumbnail : 'https://cdn.discordapp.com/attachments/746242308084858900/848762736255172679/default-placeholder.png'"
                    class="rounded w-full"/>
                </div>
              </div>

              <!-- Information - Course Information -->
              <div class="vx-col flex-1" id="account-info-col-1">
                <table v-if="simulation_data">
                  <tr>
                    <td class="font-semibold">Name</td>
                    <td>{{ simulation_data.name }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Type</td>
                    <td>{{ simulation_data.type.charAt(0).toUpperCase() + simulation_data.type.slice(1)}}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Difficulty</td>
                    <td>{{ simulation_data.difficulty }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Status</td>
                    <td>{{ simulation_data.status.charAt(0).toUpperCase() + simulation_data.status.slice(1)}}</td>
                  </tr>
                  <tr v-if="simulation_legacy_data">
                    <td class="font-semibold" >Total Score</td>
                    <td>{{ simulation_legacy_data.total_score }}</td>
                  </tr>
                </table>
              </div>

              <!-- /Information - Col 2 -->
              <div class="vx-col w-full flex mt-2" id="account-manage-buttons">
                <vs-button icon-pack="feather" icon="icon-edit" class="mr-4"
                           :to="{name: 'management-edit-simulation', params: { courseId: $route.params.simulationId }}">Edit
                </vs-button>
                <vs-button color="success" icon-pack="feather" icon="icon-play" class="mr-4"
                           :to="`/simulation/l/${$route.params.simulationId}/play`">Play
                </vs-button>
                <!--- <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash"
                           @click="confirmDeleteRecord">Archive
                </vs-button> --->
              </div>
            </div>
          </vx-card>
        </div>

        <div class="vx-col lg:w-4/12 w-full">
          <!-- Textarea Course Description -->
          <vx-card title="Simulation Description" class="mb-base" v-if="simulation_data">
            <vs-textarea v-model="simulation_data.description" counter="400"
                         :counter-danger.sync="module_description_counter" height="230px" disabled/>
          </vx-card>
        </div>

        <div class="vx-col lg:w-4/12 w-full">
          <!-- Textarea Course Description -->
          <vx-card title="Simulation Demonstration Video" class="mb-base ">
            <span class="flex items-center justify-center" v-if="simulation_data && simulation_data.demonstration_video_id">
              <iframe
              :src="'https://iframe.videodelivery.net/' +simulation_data.demonstration_video_id + '?poster=https%3A%2F%2Fvideodelivery.net%2F' +simulation_data.demonstration_video_id + '%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D68s%26height%3D270'"
              style="border: none; width: 100%" height="250" class="embed-responsive-item"
              allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
              allowfullscreen="true"></iframe>
              </span>
            <h6 v-else>No Simulation Demonstration Video</h6>
          </vx-card>

        </div>
      </div>


      <div class="vx-row match-height">

        <div class="vx-col lg:w-8/12 w-full">
          <!-- Textarea Course Description -->
          <vx-card title="Simulation Instructions" class="mb-base">
            <quill-editor  v-if="simulation_data" v-model="simulation_data.instructions_content"></quill-editor>
            <div class="flex justify-end items-end mt-4">
            <vs-button icon-pack="feather" icon="icon-edit" @click="update_instruction_data">Update Instructions</vs-button>
            </div>
          </vx-card>

        </div>

      </div>
    </div>
  </div>
</template>

<script>

import 'quill/dist/quill.snow.css'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import VxTimeline          from '@/components/timeline/VxTimeline.vue'

import { quillEditor } from 'vue-quill-editor'


export default {
  data () {
    return {
      simulation_data: null,
      simulation_legacy_data: null,
      module_description_counter: false,

      errorOccurred: false,


      difficulties: [
        {id: '0', name: 'Simple'},
        {id: '1', name: 'Easy'},
        {id: '2', name: 'Moderate'},
        {id: '3', name: 'Hard'},
        {id: '4', name: 'Challenging'}
      ]
    }
  },
  components: {
    StatisticsCardLine,
    VxTimeline,
    quillEditor
  },
  methods: {
    fetch_simulation_details (id) {

      this.$http.get(`simulations/${id}`)
        .then(response => {

          if (response.status === 200) {
            this.simulation_data = response.data.data
            this.simulation_data.difficulty =  this.difficulties.find((x) => parseInt(x.id) === parseInt(response.data.data.difficulty)).name
            this.fetch_legacy_details(id)
          }

        })
        .catch(error => {
          this.errorOccurred = true
          this.error_msg = error
        })

    },
    fetch_legacy_details (id) {

      this.$http.get(`simulations/legacy/${id}`)
        .then(response => {

          if (response.status === 200) {
            this.simulation_legacy_data = response.data.data
          }

        })
        .catch(() => {
          return this.$vs.notify({
            color: 'danger',
            title: 'No Legacy Simulation',
            text: 'This simulation does not have its contents set as a legacy simulation',
            position: 'top-right'
          })
        })
    },
    update_instruction_data () {
      this.$vs.loading()
      const pl = {
        instructions_content: this.simulation_data.instructions_content
      }

      this.$http.post(`simulations/${this.$route.params.simulationId}`, pl)
        .then(response => {

          if (response.status === 200) {
            this.$vs.loading.close()
            this.simulation_data = response.data.data
            this.$vs.notify({
              color: 'success',
              title: 'Simulation Instructions Updated',
              text: 'The simulations instructions were updated successfully',
              position: 'top-right'
            })

          }

        }).catch(exception => {
          this.$vs.loading.close()

          let error = 'An unknown error occurred while loading the course list'
          if (exception.response) {
            error = exception.response.data.error.description
          }

          return this.$vs.notify({
            title: 'Failed to load course list',
            text: error,
            color: 'danger',
            position: 'top-right'
          })
        })
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',

        title: 'Confirm Archive',
        text: 'Please confirm you want to archive this simulation.',
        accept: this.deleteRecord,
        acceptText: 'Archive'
      })
    },
    deleteRecord () {

      this.$vs.notify({
        color: 'danger',
        title: 'Can\'t archive simulation',
        text: 'At the moment simulations can\'t be archived. Contact +1-647-244-0868 or cameron@voriant.com',
        position: 'top-right'
      })

    }
  },
  mounted () {
    this.fetch_simulation_details(this.$route.params.simulationId)
  }
}

</script>

<style lang="scss">

.ql-editor{
  min-height:310px;
}

#avatar-col {
  width: 15rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width: 1201px) and (max-width: 1211px),
only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

</style>
